import { Avatar, AvatarGroup, Box, Stack, Typography } from '@mui/material';
import React, { Children } from 'react';
import { appConfig } from 'utils/config';

const MemberTribe = ({ tribeMembers = [], maxMembers }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <AvatarGroup
        max={4}
        sx={{
          '& .MuiAvatarGroup-avatar': {
            fontSize: { xs: '10px', md: '12px' },

            '&:first-of-type': {
              display: tribeMembers?.length > 3 ? 'none' : 'block',
            },
          },
        }}
      >
        {Children.toArray(
          tribeMembers?.map(({ user, profilePictureMember, nameMember }) => (
            <Avatar
              alt={user.firstName || nameMember}
              src={`${appConfig.baseUrl}${
                user.profilePicture || profilePictureMember
              }`}
              sx={{
                width: '20px',
                height: '20px',
                borderRadius: '100%',
                display: 'flex !important',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            />
          )),
        )}
      </AvatarGroup>

      <Typography
        typography={{ xs: 'captionreguler', md: 'paragraph2' }}
        color="neutral400.main"
      >
        <Box
          component="span"
          color="primaryBrandPurwadhika.main"
          fontWeight={{ xs: 600, md: 500 }}
        >
          {tribeMembers?.length}
        </Box>
        /{maxMembers} Members
      </Typography>
    </Stack>
  );
};

export default MemberTribe;
